// import React, { useState, useEffect } from "react";
// import { Input, Button } from "antd";
// import moment from "moment";

// const AnniversaryCell = ({ createdOn, record, sendAnniversaryReward }) => {
//     const [amount, setAmount] = useState("");
//     const [amcModal, setAmcModal] = useState(false);

//     const createdDate = new Date(createdOn);
//     const now = new Date();
//     const currentYear = now.getFullYear();
//     const yearsCompleted = currentYear - createdDate.getFullYear();

//     const nextAnniversary = new Date(createdDate);
//     nextAnniversary.setFullYear(currentYear);
//     if (nextAnniversary < now) {
//         nextAnniversary.setFullYear(currentYear + 1);
//     }

//     const currentAnniversary = new Date(createdDate);
//     currentAnniversary.setFullYear(createdDate.getFullYear() + yearsCompleted);

//     const msInDay = 1000 * 60 * 60 * 24;
//     const daysToAnniversary = Math.floor((nextAnniversary - now) / msInDay);
//     const isTodayAnniversary = now.toDateString() === currentAnniversary.toDateString();
//     const isNearAnniversary = daysToAnniversary >= -10 && daysToAnniversary <= 10;

//     let message = `Joined on ${moment(createdDate).format("DD-MM-YYYY")}`;
//     let bgColor = "";

//     if (isTodayAnniversary && yearsCompleted > 0) {
//         message = `🎉 ${yearsCompleted} Year Completed!`;
//         bgColor = "#e6ffe6";
//     } else if (isNearAnniversary && yearsCompleted > 0) {
//         if (daysToAnniversary > 0) {
//             message = `⏳ ${daysToAnniversary} days left for anniversary`;
//         } else {
//             message = `🎊 Anniversary was ${Math.abs(daysToAnniversary)} days ago`;
//         }
//         bgColor = "#fff8e6";
//     }

    
//     useEffect(() => {
//         if (
//             (isTodayAnniversary || (isNearAnniversary && daysToAnniversary < 0)) &&
//             yearsCompleted > 0
//         ) {
//             setAmcModal(true);
//         } else {
//             setAmcModal(false);
//         }
//     }, [isTodayAnniversary, isNearAnniversary, yearsCompleted, daysToAnniversary]);
// console.log(daysToAnniversary,isNearAnniversary,"daysToAnniversary");
//     const handleSend = () => {
//         if (amount) {
//             sendAnniversaryReward(record, amount, nextAnniversary);
//             setAmount("");
//             setAmcModal(false);
//         }
//     };

//     return (
//         <div style={{ backgroundColor: bgColor, padding: "4px", borderRadius: "4px" }}>
//             <div>{message}</div>
//             {amcModal && (
//                 <>
//                     <Input
//                         size="small"
//                         placeholder="Charges ₹"
//                         style={{ width: 100, marginTop: 4, marginRight: 8 }}
//                         value={amount}
//                         onChange={(e) => setAmount(e.target.value)}
//                     />
//                     <Button size="small" type="primary" onClick={handleSend}>
//                         Send
//                     </Button>
//                 </>
//             )}
//         </div>
//     );
// };

// export default AnniversaryCell;


import React, { useState, useEffect } from "react";
import { Input, Button } from "antd";
import moment from "moment";

const AnniversaryCell = ({ createdOn, record, sendAnniversaryReward }) => {
    const [amount, setAmount] = useState("");
    const [amcModal, setAmcModal] = useState(false);

    const createdDate = moment(createdOn);
    const now = moment();
    const currentYear = now.year();

    const yearsCompleted = currentYear - createdDate.year();

    const anniversaryDateThisYear = moment(createdDate).year(currentYear);
    if (anniversaryDateThisYear.isBefore(now, "day")) {
        anniversaryDateThisYear.add(1, "year");
    }

    const currentAnniversary = moment(createdDate).add(yearsCompleted, "years");
    const daysToAnniversary = anniversaryDateThisYear.diff(now, "days");

    const daysAfterAnniversary = now.diff(currentAnniversary, "days");
    const isTodayAnniversary = now.isSame(currentAnniversary, "day");
    const isNearAnniversary = Math.abs(daysToAnniversary) <= 10;
    const isEligibleToSend = isTodayAnniversary || (daysAfterAnniversary >= 0 && daysAfterAnniversary <= 10);

    // 🎯 Message Setup
    let message = `Joined on ${createdDate.format("DD-MM-YYYY")}`;
    let bgColor = "";

    if (isTodayAnniversary && yearsCompleted > 0) {
        message = `🎉 ${yearsCompleted} Year Completed!`;
        bgColor = "#e6ffe6";
    } else if (isNearAnniversary && yearsCompleted > 0 || isEligibleToSend) {
        if (daysToAnniversary > 0 && isNearAnniversary) {
            message = `⏳ ${daysToAnniversary} day${daysToAnniversary > 1 ? "s" : ""} left for anniversary`;
        } else if(isEligibleToSend) {
            message = `🎊 Anniversary was ${Math.abs(daysAfterAnniversary)} day${Math.abs(daysAfterAnniversary) > 1 ? "s" : ""} ago`;
        }
        bgColor = "#fff8e6";
    }
// console.log(isEligibleToSend,message,isNearAnniversary,daysToAnniversary,daysAfterAnniversary,"daysToAnniversary");
    useEffect(() => {
        if (isEligibleToSend && yearsCompleted > 0) {
            setAmcModal(true);
        } else {
            setAmcModal(false);
        }
    }, [isEligibleToSend, yearsCompleted]);

    const handleSend = () => {
        if (amount) {
            sendAnniversaryReward(record, amount, currentAnniversary.toDate());
            setAmount("");
        }
    };

    return (
        <div style={{ backgroundColor: bgColor, padding: "4px", borderRadius: "4px" }}>
            <div>{message}</div>
            {amcModal && (
                <>
                    <Input
                        size="small"
                        placeholder="Charges ₹"
                        style={{ width: 100, marginTop: 4, marginRight: 8 }}
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                    <Button size="small" type="primary" onClick={handleSend}>
                        Send
                    </Button>
                </>
            )}
        </div>
    );
};

export default AnniversaryCell;
